import Vue from 'vue'
import Router from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout'

import Main from '@/pages/Main'
import Login from '@/pages/Login'

const PeripheralsList = () => import('@/pages/PeripheralsList');
const PeripheryItem = () => import('@/pages/PeripheryItem');
const Details = () => import('@/pages/Details');
const DetailItem = () => import('@/pages/DetailItem');
const BoardList = () => import('@/pages/BoardList');
const BoardItem = () => import('@/pages/BoardItem');
const ProjectList = () => import('@/pages/ProjectList');
const ProjectItem = () => import('@/pages/ProjectItem');
const OrderList = () => import('@/pages/OrderList');
const OrderItem = () => import('@/pages/OrderItem');
const UserList = () => import('@/pages/UserList');
const UserItem = () => import('@/pages/UserItem');
const ProviderList = () => import('@/pages/ProviderList');
const ProviderItem = () => import('@/pages/ProviderItem');
const ClientList = () => import('@/pages/ClientList');
const ClientItem = () => import('@/pages/ClientItem');
const StockMovement = () => import('@/pages/StockMovement');
const Inventory = () => import('@/pages/Inventory');
const PasswordResetStart = () => import('@/pages/PasswordResetStart');
const PasswordResetConfirm = () => import('@/pages/PasswordResetConfirm');
const PageNotFound = () => import('@/pages/PageNotFound');

Vue.use(Router)

const forAnonUsersOnly = (to, from, next) => (
  (localStorage.getItem('token')) ? next({ path: '/main' }) : next()
);

const forAuthorizedUsersOnly = (to, from, next) => (
  !localStorage.getItem('token') ? next({ path: '/public/login' }) : next()
);

const router = new Router({
  routes: [
    { path: '/',
      name: 'Home',
      redirect: '/main',
      component: DefaultLayout,
      children: [
        { path: '/main', name: 'Main', component: Main, props: true },
        { path: '/inventory', name: 'Inventory', component: Inventory },
        { path: '/details', name: 'Details', component: Details },
        { path: '/details/:id', name: 'DetailItem', component: DetailItem },
        { path: '/circuit_boards', name: 'BoardList', component: BoardList },
        { path: '/circuit_boards/:id', name: 'BoardItem', component: BoardItem },
        { path: '/projects', name: 'ProjectList', component: ProjectList },
        { path: '/projects/:id', name: 'ProjectItem', component: ProjectItem },

        { path: '/peripherals', component: PeripheralsList },
        { path: '/peripherals/:id', component: PeripheryItem },

        { path: '/orders', name: 'OrderList', component: OrderList },
        { path: '/orders/:id', name: 'OrderItem', component: OrderItem },

        { path: '/users', name: 'UserList', component: UserList },
        { path: '/users/:id', name: 'UserItem', component: UserItem },

        { path: '/providers', name: 'ProviderList', component: ProviderList },
        { path: '/providers/:id', name: 'ProviderItem', component: ProviderItem },

        { path: '/clients', name: 'ClientList', component: ClientList },
        { path: '/clients/:id', name: 'ClientItem', component: ClientItem },

        { path: '/stock_movement', name: 'StockMovement', component: StockMovement },
      ],
      beforeEnter: forAuthorizedUsersOnly,
    },
    {
      path: '/public/password_reset/:token',
      component: PasswordResetConfirm,
      beforeEnter: forAnonUsersOnly,
    },
    {
      path: '/public/password_reset',
      component: PasswordResetStart,
      beforeEnter: forAnonUsersOnly,
    },
    {
      path: '/public/login',
      component: Login,
      beforeEnter: forAnonUsersOnly,
    },
    {
      path: '/:pathMatch(.*)*',
      component: PageNotFound,
    },
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js